/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "./type";
export var ElevationMode = /*@__PURE__*/ (function (ElevationMode) {
    ElevationMode[ElevationMode["Auto"] = 0] = "Auto";
    ElevationMode[ElevationMode["MaterialShadow"] = 1] = "MaterialShadow";
    ElevationMode[ElevationMode["HaloShadow"] = 2] = "HaloShadow";
    return ElevationMode;
})({});
/**
 * @hidden
 */
export var ElevationMode_$type = /*@__PURE__*/ markEnum('ElevationMode', 'Auto,0|MaterialShadow,1|HaloShadow,2');
//# sourceMappingURL=ElevationMode.js.map
